import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.answerInfo.loading;
export const answerInfoErrorMessage = (state: RootState) =>
  state.answerInfo.error;
export const answerInfoDataResponse = (state: RootState) =>
  state.answerInfo.answerInfoResponse;
